import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.MatrizTarifaDTO;
import { columnas } from "./columns";
const resource = resources.MatrizTarifa;
const observable = observeResource(resources.MatrizTarifa.query);
export class MatrizTarifaList extends React.PureComponent {
    onBorrar = async (x: Entity) => {
        if (await kea.yesno("¿Borrar matriz de tarifas?", x.Nombre)) {
            await resource.delete(x.IdRegistro);
        }
    }

    OnDuplicar = async (x: Entity) => {
        if (await kea.yesno("¿Duplicar matriz de tarifas?", x.Nombre)) {
            var idRegistro = await resource.DuplicarMatriz(x.IdRegistro);
            await kea.message("Matriz de tarifas duplicadas");
            history.go(`./${idRegistro}`);
        }
    }

    onEdit = (x: Entity) => history.go("/catalogos/MatrizTarifa/" + x.IdRegistro);
    onAgregar = () => history.go("/catalogos/MatrizTarifa/new");
    onRegresar = () => history.go("/catalogos");

    render() {
        const cols = columnas(this);
        return (
            <div>
                <kea.Title titulo="Matrices de tarifas" onRegresar={this.onRegresar}>
                    <kea.AgregarButton onClick={this.onAgregar} />
                </kea.Title>

                <kea.Link onClick={() => history.go("/catalogos/Tarifa/")} >Ir a tarifas / convenios</kea.Link>

                <kea.Grid2 columnas={cols} cookieKey={"MatrizTarifaListCookieKey"} items={observable} />
            </div>
        )
    }

}



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/matricestarifa/list/list.tsx